<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>緊急通報チーム変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>チーム名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="room.roomName" class="form-control" autocomplete="off" placeholder="チーム名" required>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label>メンバー（2〜50名）</label>
                <button type="button" class="btn btn-sm btn-outline-primary" v-on:click="openModal">追加する</button>
              </div>
              <div class="col-9">
                <table class="table table-sm table-hover form-table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" style="width:80px"></th>
                      <th scope="col">ID</th>
                      <th scope="col">名称</th>
                      <th scope="col">実行権限</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="member in members" v-bind:key="member.userId">
                      <td>
                        <button type="button" class="btn-sm" v-on:click="remove(member.userId)">
                          <img class="times-solid" src="/times-solid.svg">
                        </button>
                      </td>
                      <td>{{ member.User.userCode }}</td>
                      <td>{{ member.User.userName }}</td>
                      <td>
                        <input type="radio" v-bind:id="'both' + member.userId" v-bind:value="privilege.both" v-model="member.privilege"><label v-bind:for="'both' + member.userId" class="radio">発着信可能</label>
                        <input type="radio" v-bind:id="'outgoing' + member.userId" v-bind:value="privilege.outgoing" v-model="member.privilege"><label v-bind:for="'outgoing' + member.userId" class="radio">発信のみ</label>
                        <input type="radio" v-bind:id="'incoming' + member.userId" v-bind:value="privilege.incoming" v-model="member.privilege"><label v-bind:for="'incoming' + member.userId" class="radio">着信のみ</label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
    <MemberModal v-show="showContent" v-on:close-modal="closeModal" v-on:add-member="addMember($event)" v-bind:members="members" v-bind:parentName="name" v-bind:exclusionId="roomId" v-bind:realms="realms"/>
  </div>
</template>

<script>
import axios from 'axios'
import MemberModal from './../../components/MemberModal'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms'],
  components: {
    MemberModal
  },
  data: function(){
    return {
      name: 'group',
      message: '',
      room: {
        roomName: ''
      },
      members: [],
      roomId: this.$route.params.id,
      privilege: {
        both: "1",
        outgoing: "2",
        incoming: "3"
      },
      showContent: false
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var roomId = this.$route.params.id;
        axios.get("/api/emergency/room/" + roomId, {
            headers: this.headers(accessToken)
        }).then(response => {
          this.room = response.data.data.room;
          this.members = response.data.data.members;
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    remove(id) {
      var index = this.members.findIndex((element) => element.userId === id)
      this.members.splice(index,1)
    },
    modify() {
      var memberNum = this.members.length
      if (memberNum < 2) {
        this.message = '2名以上のユーザーを登録して下さい。'
        return
      }
      if (this.members.filter((member) => member.privilege == this.privilege.outgoing).length == memberNum) {
        this.message = '着信可能なユーザーが存在しません。登録内容を確認して下さい。'
        return
      }
      if (this.members.filter((member) => member.privilege == this.privilege.incoming).length == memberNum) {
        this.message = '発信可能なユーザーが存在しません。登録内容を確認して下さい。'
        return
      }
      if (this.room.roomName.startsWith("maintenanceuser")) {
        this.message = "チーム名称を変更してください"
        return
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.put("/api/emergency/room", {
              room: this.room,
              members: this.members
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/emergency/group/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/emergency/group/index'))
    },
    destroy() {
      if(confirm('削除してもよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var roomId = this.$route.params.id;
          axios.delete("/api/emergency/room/" + roomId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/emergency/group/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
    openModal(){
      this.showContent = true
    },
    closeModal(){
      this.showContent = false
    },
    addMember(event){
      this.members = event
      this.closeModal()
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.radio{
  margin-right: 15px;
}
</style>